var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisualizar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.6,
    height: 13.073,
    viewBox: "0 0 17.6 13.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-eye",
    "data-name": "Icon feather-eye",
    transform: "translate(-1 -5.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36",
    "data-name": "Trazado 36",
    d: "M1.5,12.036S4.518,6,9.8,6s8.3,6.036,8.3,6.036-3.018,6.036-8.3,6.036S1.5,12.036,1.5,12.036Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_37",
    "data-name": "Trazado 37",
    d: "M20.251,16.875A3.375,3.375,0,1,1,16.875,13.5,3.375,3.375,0,0,1,20.251,16.875Z",
    transform: "translate(-7.075 -4.839)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualizar);
export default __webpack_public_path__ + "static/media/visualizar.032c38583171b75860994880b118539d.svg";
export { ForwardRef as ReactComponent };